// extracted by mini-css-extract-plugin
export default {"vlLogo":"style_vlLogo__8pcr0"};